// extracted by mini-css-extract-plugin
export var panelSpaceBottom = "ContentCards3-module--panel-space-bottom--027c5";
export var panelSpaceTop = "ContentCards3-module--panel-space-top--bd96e";
export var section = "ContentCards3-module--section--b6db7";